import * as PlaybackStateActions from "actions/PlaybackStateActions";
import getDuration from "selectors/chapter/getDuration";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import getTimeMarkerWidth from "selectors/styles/getTimeMarkerWidth";
import Slider from "components/Slider";
import { compose, fromRenderProps, setDisplayName } from "recompose";
import { connect } from "react-redux";
import { WithSliderDimensions } from "context/Slider";

const connector = connect(
  (state, ownProps) => {
    const playbackState = getPlaybackState(state, ownProps);
    const valueMax = getDuration(state, ownProps);
    const time = playbackState ? playbackState.time : 0;
    return {
      scrubbing: playbackState ? playbackState.scrubbing : false,
      seeking: playbackState ? playbackState.seeking : false,
      timeMarkerWidth: getTimeMarkerWidth(state, ownProps),
      valueMax,
      valueNow: Math.min(valueMax, time),
    };
  },
  undefined,
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    disabled: ownProps.disabled || !ownProps.onSlideStart,
    seekForward() {
      dispatchProps.dispatch(PlaybackStateActions.seekForward(ownProps));
    },
    seekBack() {
      dispatchProps.dispatch(PlaybackStateActions.seekBack(ownProps));
    },
  }),
);

export default compose(
  setDisplayName("SliderContainer"),
  fromRenderProps(WithSliderDimensions, ({ sliderDimensions }) => ({
    sliderWidth: sliderDimensions.width,
  })),
  connector,
)(Slider);
